var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.833 9L18.7755 10.0575L13.083 4.3725V18.75H11.583V4.3725L5.89051 10.0575L4.83301 9L12.333 1.5L19.833 9ZM19.833 18V21H4.83301V18H3.33301V21C3.33301 21.8284 4.00458 22.5 4.83301 22.5H19.833C20.6614 22.5 21.333 21.8284 21.333 21V18H19.833Z",
    fill: "#E20074"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.fabb442190f41731e198326cff58e8f4.svg";
export { ForwardRef as ReactComponent };